/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hist_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The number of bins defaults to about the square root of the sample size, clamped between 5 and 20, which works well for most data sets.`)
};

const es_hist_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El número de intervalos por defecto es aproximadamente la raíz cuadrada del tamaño de la muestra, limitado entre 5 y 20, lo cual funciona bien para la mayoría de los conjuntos de datos.`)
};

const de_hist_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Anzahl der Klassen entspricht standardmäßig etwa der Quadratwurzel der Stichprobengröße, begrenzt zwischen 5 und 20, was für die meisten Datensätze gut funktioniert.`)
};

const nl_hist_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het aantal klassen is standaard ongeveer de vierkantswortel van de steekproefgrootte, begrensd tussen 5 en 20, wat goed werkt voor de meeste datasets.`)
};

const fr_hist_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nombre de classes est par défaut environ la racine carrée de la taille de l'échantillon, limité entre 5 et 20, ce qui fonctionne bien pour la plupart des jeux de données.`)
};

const it_hist_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il numero di classi è predefinito a circa la radice quadrata della dimensione del campione, limitato tra 5 e 20, il che funziona bene per la maggior parte dei set di dati.`)
};

const pt_br2_hist_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O número de bins tem como padrão aproximadamente a raiz quadrada do tamanho da amostra, limitado entre 5 e 20, o que funciona bem para a maioria dos conjuntos de dados.`)
};

const pt_hist_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O número de classes assume por padrão cerca da raiz quadrada do tamanho da amostra, limitado entre 5 e 20, o que funciona bem para a maioria dos conjuntos de dados.`)
};

const ja_hist_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビンの数はデフォルトでサンプルサイズの平方根程度になり、5から20の間にクランプされます。ほとんどのデータセットでうまく機能します。`)
};

const zh_hist_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱数默认约为样本量的平方根，并限制在 5 到 20 之间，这对大多数数据集都适用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hist_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hist_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hist_faq_a2", locale)
	if (locale === "en") return en_hist_faq_a2(inputs)
	if (locale === "es") return es_hist_faq_a2(inputs)
	if (locale === "de") return de_hist_faq_a2(inputs)
	if (locale === "nl") return nl_hist_faq_a2(inputs)
	if (locale === "fr") return fr_hist_faq_a2(inputs)
	if (locale === "it") return it_hist_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_hist_faq_a2(inputs)
	if (locale === "pt") return pt_hist_faq_a2(inputs)
	if (locale === "ja") return ja_hist_faq_a2(inputs)
	return zh_hist_faq_a2(inputs)
};